"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _fontDefinitions = _interopRequireDefault(require("./fontDefinitions"));

var _global = _interopRequireDefault(require("../../base/global"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Types TLC
var eCommGlobal = (0, _tslib.__spreadArrays)(_global.default, [_fontDefinitions.default]);
var _default = eCommGlobal;
exports.default = _default;